<svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 226.77 226.77"
    class="telemetry-icon"
    [class]="status()"
>
    <path
        class="radio-tower"
        d="M125.65,61.28c0,6.76-5.48,12.23-12.23,12.23-1.44,0-2.82-.25-4.1-.7-4.74-1.68-8.14-6.21-8.14-11.53,0-6.76,5.48-12.23,12.23-12.23s12.23,5.48,12.23,12.23Z"
    />
    <line class="radio-tower" x1="117.28" y1="73.33" x2="157.6" y2="210.35" />
    <line class="radio-tower" x1="109.69" y1="73.68" x2="69.47" y2="210.35" />
    <line class="radio-tower" x1="74.1" y1="195.55" x2="139.47" y2="152.84" />
    <line class="radio-tower" x1="152.38" y1="195.55" x2="87.01" y2="152.84" />
    <line class="radio-tower" x1="87.42" y1="150.84" x2="130.54" y2="122.66" />
    <line class="radio-tower" x1="139.06" y1="150.84" x2="95.94" y2="122.66" />
    <line class="radio-tower" x1="97.1" y1="120.05" x2="124.06" y2="102.44" />
    <line class="radio-tower" x1="129.38" y1="120.05" x2="102.42" y2="102.44" />
    <path
        class="radio-tower"
        d="M70.55,107.54c-11.94-11.02-19.53-27.52-19.53-45.98,0-17.99,7.21-34.13,18.64-45.14"
    />
    <path
        class="radio-tower"
        d="M81.5,97.04c-9.64-8.22-15.84-21.05-15.84-35.48,0-13.77,5.65-26.08,14.54-34.32"
    />
    <path
        class="radio-tower"
        d="M92.46,85.77c-7.2-5.16-11.95-14.07-11.95-24.2,0-9.54,4.21-18,10.71-23.26"
    />
    <path
        class="radio-tower"
        d="M156.22,107.54c11.94-11.02,19.53-27.52,19.53-45.98,0-17.99-7.21-34.13-18.64-45.14"
    />
    <path
        class="radio-tower"
        d="M145.28,97.04c9.64-8.22,15.84-21.05,15.84-35.48,0-13.77-5.65-26.08-14.54-34.32"
    />
    <path
        class="radio-tower"
        d="M134.31,85.77c7.2-5.16,11.95-14.07,11.95-24.2,0-9.54-4.21-18-10.71-23.26"
    />
</svg>
